import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/propietarios",
    label: "Propietarios",
  },
  {
    path: "/crear",
    label: "Crear",
    isActive: true,
  },
];

function CrearPropietario() {
  return (
    <Page
      title="Registro de Propietario"
      description="Creación de propietarios."
      breadCrumbs={breadCrumbs}
    >
      <FormSection />
    </Page>
  );
}

export default CrearPropietario;
